module.exports = __webpack_public_path__ + "84436968821a47d6e3efdfbfb487cb2a.svg";